var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-date"},[_c('InputMask',{attrs:{"id":_vm.Id,"mask":"99/99/9999","slotChar":"__/__/____","value":_vm.value,"disabled":_vm.Readonly},on:{"input":_vm.onInternalValueChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }